<template>
  <div
    v-if="unsuccessful && !hasError"
    class="toast toast-warning"
    role="alert"
  >
    <button
      v-on:click="clear"
      class="btn btn-clear float-right"
      aria-label="Clear warning"
    ></button>
    Warning:
    <a v-on:click="viewDetails" href="#">
      {{ message }}
    </a>
  </div>
</template>

<script>
import ConfigStore from "../stores/ConfigStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";
import IOStore from "../stores/IOStore";

export default {
  name: "SuccessToast",
  computed: {
    unsuccessType() {
      if (!PFStore.methods.success()) {
        return "pf";
      } else if (!OPFStore.methods.success()) {
        return "opf";
      } else {
        return "";
      }
    },
    unsuccessful() {
      return !PFStore.methods.success() || !OPFStore.methods.success();
    },
    message() {
      if (!PFStore.methods.success()) {
        return "Power flow did not succeed";
      } else if (!OPFStore.methods.success()) {
        return "OPF did not succeed";
      }
      return "";
    },
    hasError() {
      let io = IOStore.methods.error().length !== 0;
      let pf = PFStore.methods.error().length !== 0;
      let opf = OPFStore.methods.error().length !== 0;
      return io || pf || opf;
    }
  },
  methods: {
    viewDetails() {
      ConfigStore.data.config.outputTab = this.unsuccessType;
    },
    clear() {
      switch (this.unsuccessType) {
        case "pf":
          PFStore.methods.success(true);
          break;
        case "opf":
          OPFStore.methods.success(true);
          break;
      }
    }
  }
};
</script>
